module.exports = __webpack_public_path__ + "static/media/lake-tekapo.de393dd8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photography/lake-tekapo.jpg
// module id = 134
// module chunks = 0